// 应用外壳薄壳（LeapWorldUI-08）：布局本体已下沉 @bf/ui AppShell（D29；形态 T139：
// 桌面 w-56 侧栏 + 移动细顶栏 + w-64 抽屉，用户区在侧栏底部），本文件只做装配——
// nav.ts 映射成 ShellNavGroup[]（按 capabilities 过滤，与服务端鉴权共用
// shared/capabilities.ts 枚举；加导航仍只改 nav.ts）、品牌区/用户区操作位注入。
// 导航图标登记制接入（11-ui-kit §10，LeapWorldTwin-113）：icon 随 nav.ts 各项透传；
// 品牌区改 BrandGlyph 单字标 + 应用名/副标题文本。路由表见 src/App.tsx。

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  AppShell,
  Avatar,
  BrandGlyph,
  VersionBadge,
  NotificationBell,
  type NotificationBellProps,
  type ShellNavGroup,
} from "@bf/ui";
import { CAPABILITY_LABELS } from "../../../shared/capabilities";
import { useAuth } from "../../lib/auth";
import { NAV_GROUPS } from "./nav";
import { api } from '../../lib/api';
const loadNotifications: NotificationBellProps['load'] = (cursor) => api.get('/notifications', { query: { cursor } });
const markNotificationsRead: NotificationBellProps['markRead'] = (input) => api.post('/notifications/mark-read', input);

export function AppLayout() {
  const { user, logout, capabilities, hasCapability } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!user) return null;

  const primaryCapability = capabilities.find((capability) => capability !== "employee") ?? "employee";
  const roleLabel = CAPABILITY_LABELS[primaryCapability];

  // react-router 消费形态：href + onSelect 同给，AppShell 点击时 preventDefault 走 SPA 跳转；
  // /help/ 是 SPA 外静态页，只给 href 整页跳转（旧布局同为裸 <a>）。
  const nav: ShellNavGroup[] = NAV_GROUPS.map((group) => ({
    title: group.title,
    items: group.items
      .filter((item) => hasCapability(...item.anyOf))
      .map((item) => ({
        key: item.to,
        label: item.label,
        icon: item.icon,
        href: item.to,
        active: item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`),
        onSelect: item.to === "/help/" ? undefined : () => navigate(item.to),
      })),
  })).filter((group) => group.items.length > 0);

  return (
    <AppShell
      brand={
        <span className="flex min-w-0 items-center gap-2.5">
          <BrandGlyph>积</BrandGlyph>
          <span className="block min-w-0">
            <span className="block truncate text-sm font-bold text-ink">跃迁积分</span>
            <span className="mt-0.5 block truncate text-xs font-normal text-faint">内部积分激励管理系统</span>
          </span>
        </span>
      }
      mobileBrand="跃迁积分"
      nav={nav}
      user={{ name: user.name, detail: roleLabel }}
      userActions={
        <button
          type="button"
          aria-label="退出登录"
          title="退出登录"
          onClick={() => void logout()}
          className="shrink-0 rounded-md px-1.5 py-1 text-xs text-muted hover:bg-soft hover:text-ink max-md:min-h-11"
        >
          退出
        </button>
      }
      topBarEnd={<Avatar name={user.name} size="sm" />}
      versionBadge={(align) => <div className="flex items-center gap-1"><NotificationBell load={loadNotifications} markRead={markNotificationsRead} align={align} /><VersionBadge align={align} /></div>}
    >
      <Outlet />
    </AppShell>
  );
}
